import axios from "axios"
import pcoUrl from "@planningcenter/url"
import { isObject } from "utils/helpers"

export const axiosRequest = (method, requestPath, attributes) => {
  let app = "registrations"
  let path = requestPath

  if (isObject(requestPath)) {
    app = requestPath.app
    path = requestPath.path
  }

  const url = `${pcoUrl(window.railsEnv)("api")}/${app}/v2/${path}`

  return axios({
    method,
    url,
    ...(attributes && { data: { data: { ...attributes } } }),
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": $.rails.csrfToken()
    }
  })
    .then(res => res.data)
    .catch(error => Promise.reject(error))
}

const request = async (method, url, params, { usePromise }) => {
  try {
    const response = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": $.rails.csrfToken()
      },
      credentials: "include",
      body: JSON.stringify(params)
    })

    let json
    try {
      json = JSON.parse(await response.text())
    } catch (error) {
      json = {}
    }

    const responseJson = {
      ...json,
      status: response.status,
      request: { url, method, params }
    }

    if (!response.ok) {
      return usePromise ? Promise.reject(responseJson) : responseJson
    }

    return usePromise ? Promise.resolve(responseJson) : responseJson
  } catch (error) {
    return usePromise ? Promise.reject(error) : error
  }
}

export const api = {
  get(url, params) {
    return request("get", url, params, { usePromise: true })
  },
  post(url, params) {
    return request("post", url, params, { usePromise: true })
  },
  put(url, params) {
    return request("put", url, params, { usePromise: true })
  },
  patch(url, params) {
    return request("patch", url, params, { usePromise: true })
  },
  del(url, params) {
    return request("delete", url, params, { usePromise: true })
  },
  putOrPost(id, url, params) {
    return request(id ? "put" : "post", url, params, { usePromise: true })
  },
  upload(url, file, options = {}) {
    const { method = "post", paramName = "file", progressCallback = () => null } = options

    const formData = new FormData()
    formData.append("Content-Type", file.type)
    formData.append(paramName, file)

    return axios
      .request({
        method: method,
        url: url,
        withCredentials: true,
        headers: {
          "X-CSRF-Token": $.rails.csrfToken()
        },
        data: formData,
        onUploadProgress(e) {
          const progress = (e.loaded / e.total) * 100
          return progressCallback(progress)
        }
      })
      .then(data => data.data)
  }
}

export const apiAsync = {
  get(url, params) {
    return request("get", url, params, { usePromise: false })
  },
  post(url, params) {
    return request("post", url, params, { usePromise: false })
  },
  put(url, params) {
    return request("put", url, params, { usePromise: false })
  },
  patch(url, params) {
    return request("patch", url, params, { usePromise: false })
  },
  del(url, params) {
    return request("delete", url, params, { usePromise: false })
  }
}
